import { __assign } from "tslib";
import React from 'react';
import JournalMonoHtmlView from './JournalHtml';
import JournalMonoReactView from './Journal';
var JournalMonoView = function (props) {
    if (props.isHtml) {
        return React.createElement(JournalMonoHtmlView, __assign({}, props));
    }
    return React.createElement(JournalMonoReactView, __assign({}, props));
};
JournalMonoView.displayName = 'JournalMonoView';
export default JournalMonoView;
//# sourceMappingURL=index.js.map